import preact from 'preact'
import Downshift from 'downshift/preact'
import HitContainer from './HitContainer'
import HitContainerFederated from './HitContainerFederated'
import { SearchBox, doSearch } from './SearchBox'
import localStorageCache from 'utils/localStorageCache'
import { SEARCH_CONVERSION } from 'libs/config'

class AlgoliaSearch extends preact.Component {
  render ({ refine, hits, updateSearch, allSearchResults, indexName, isFederatedSearch }) {
    return (
      <Downshift
        itemToString={i => (i ? i.title : i)}
        onChange={item => {
          window.aa('click', {
            objectID: item.objectID,
            position: item.position,
            queryID: item.queryID
          })
          localStorageCache.setItem(SEARCH_CONVERSION, {
            objectID: item.objectID,
            queryID: item.queryID
          })
        }}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          setHighlightedIndex,
          closeMenu,
          openMenu,
          inputValue,
          reset,
          isOpen
        }) => <div className='algolia-search-container'>
          {
            isOpen ? (
              <div key='backdrop' onClick={closeMenu} className='algolia-search--opacity' />
            ) : null
          }
          <SearchBox
            reset={reset}
            refine={refine}
            updateSearch={updateSearch}
            setHighlightedIndex={setHighlightedIndex}
            inputValue={inputValue}
            getInputProps={getInputProps}
            openMenu={openMenu}
            isOpen={isOpen}
            key='search' />

          {
            inputValue && isOpen
              ? isFederatedSearch
                ? <HitContainerFederated key='hits-container'
                  allSearchResults={allSearchResults}
                  inputValue={inputValue}
                  doSearch={doSearch}
                  hits={hits}
                  highlightedIndex={highlightedIndex}
                  getItemProps={getItemProps}
                  indexName={indexName} />
                : <HitContainer key='hits-container'
                  allSearchResults={allSearchResults}
                  inputValue={inputValue}
                  doSearch={doSearch}
                  hits={hits}
                  highlightedIndex={highlightedIndex}
                  getItemProps={getItemProps} />
              : null
          }
        </div>
        }
      </Downshift>
    )
  }
}

export default AlgoliaSearch
